import React from 'react';

export interface ThemeContextProps<T, S> {
  overlayZIndex?: number;
  theme?: T;
  themeVariant?: S;
}

export const ThemeContext = React.createContext<
  ThemeContextProps<unknown, unknown>
>({});
